/**
 * Determines if flickity needs to be resized based on the selected image height
 *
 * @param {object} flickity - the flickity instance
 */
export default function resizeFlickityIfNeeded(flickity) {
  if (!flickity) {
    return;
  }

  const activeHeight = flickity.selectedElement.offsetHeight;
  const flickityHeight = flickity.viewport.offsetHeight;

  // If flickity height is greater than slide height, ignore
  if (activeHeight < flickityHeight) {
    return;
  }

  flickity.resize();
}
